<section class="paginacion">
	<div (click)="fnAccionPaginacion( false )" [ngClass]="{'disabled': ( currentPage === 1 ) }">
		<div>
			<i class="fas fa-angle-double-left"></i>
		</div>
	</div>
	<div>
		<div (click)="fnAccionControl()">
			{{ currentPage }} - {{ totalPaginas }}
		</div>
		<section *ngIf=" showControl " class="paginador-control">
			<input [(ngModel)]="newPage" type="text" placeholder="Ir a página">
			<button (click)="fnIrPagina()" aria-label="Buscar página"><i class="fas fa-search"></i></button>
		</section>
	</div>
	<div (click)="fnAccionPaginacion( true )" [ngClass]="{'disabled': ( currentPage === totalPaginas ) }">
		<div>
			<i class="fas fa-angle-double-right"></i>
		</div>
	</div>
</section>